import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { DatePipe } from '@angular/common';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatButton } from '@angular/material/button';
import {
  MatRadioButton,
  MatRadioChange,
  MatRadioGroup
} from '@angular/material/radio';

import { TranslatePipe } from '@ngx-translate/core';

import { UniversalTableComponent } from '@app/components/universal-table/universal-table.component';
import { SelectionMode } from '@app/shared/enums';
import { ProcedureService } from '@app/services/rfx/procedure.service';
import { IProcedure } from '@app/models';
import { ColumnDefinition, SortState } from '@app/shared/models';
import { GET_RFX_COLUMNS } from './constants/choose-rfx-modal.constants';
import { ChooseRfxModalData } from './models/choose-rfx-modal.model';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-choose-rfx-modal',
  imports: [
    UniversalTableComponent,
    DatePipe,
    TranslatePipe,
    MatRadioGroup,
    MatRadioButton,
    MatButton,
    CdkDrag,
    CdkDragHandle
  ],
  templateUrl: './choose-rfx-modal.component.html',
  styleUrl: './choose-rfx-modal.component.scss'
})
export class ChooseRfxModalComponent implements AfterViewInit, OnInit {
  public searchValue = '';
  public items: IProcedure[] = [];
  public paginationOptions = {
    pageSize: 50,
    currentPage: 1,
    totalItems: 0
  };
  public sortingOptions = {
    filterParameter: 'DateCreated',
    filterType: 'DESC'
  };
  public columns: ColumnDefinition[] = [];
  public inNewLot = false;
  public selectedProcedure: IProcedure[] = [];
  public isLoading = false;

  public readonly selectionModeSingle = SelectionMode.Single;

  @ViewChild('createDateTemplate', { static: true })
  createDateTemplate!: TemplateRef<unknown>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public outerData: ChooseRfxModalData,
    private procedureService: ProcedureService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getProcedures();
  }

  ngAfterViewInit(): void {
    this.columns = GET_RFX_COLUMNS(this.createDateTemplate);

    this.cdr.detectChanges();
  }

  public selectProcedure(procedures: IProcedure[]): void {
    this.selectedProcedure = procedures;
  }

  public onPageEventChange(pagination: PageEvent): void {
    this.paginationOptions = {
      ...this.paginationOptions,
      pageSize: pagination.pageSize,
      currentPage: pagination.pageIndex + 1
    };

    this.getProcedures();
  }

  public inNewLotChange(event: MatRadioChange): void {
    this.inNewLot = event.value;
  }

  public choose(): void {
    this.isLoading = true;
    this.outerData.save(this.selectedProcedure[0].id, this.inNewLot);
  }

  public onSortChange(sort: SortState): void {
    const { filterParameter, filterType } = sort;
    const fieldName =
      filterParameter.charAt(0).toUpperCase() + filterParameter.slice(1);
    this.sortingOptions = {
      filterParameter: fieldName,
      filterType: filterType
    };

    this.getProcedures();
  }

  private getProcedures(): void {
    this.procedureService
      .getProcedures({
        searchValue: this.searchValue,
        stage: ['Draft'],
        status: ['Active'],
        pageSize: this.paginationOptions.pageSize,
        currentPage: this.paginationOptions.currentPage,
        ...this.sortingOptions
      })
      .subscribe(data => {
        this.items = data.items;
        this.paginationOptions.totalItems = data.totalItems;
      });
  }
}
